function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { isPreBuiltLimitedCartOpenedByCustomerSelector } from 'swag-client-common/redux/cart/cart.selectors';
import { isResellerInOrderCreationModeSelector } from 'swag-client-common/redux/user/user.selectors';
import { SwagLogo as SwagLogoComponent } from './swag-logo';
const {
  swag: {
    storeSettings
  }
} = window;
const linkSelector = createSelector(isPreBuiltLimitedCartOpenedByCustomerSelector, isResellerInOrderCreationModeSelector, (isPreBuiltLimitedCart, isResellerInOrderCreationMode) => {
  if (isResellerInOrderCreationMode || isPreBuiltLimitedCart) {
    return APP_ROUTES.CART;
  }
  const homePageUrl = storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.logoLinkUrl;
  if (homePageUrl) {
    return homePageUrl;
  }
  if (storeSettings !== null && storeSettings !== void 0 && storeSettings.isHomePageActive) {
    return APP_ROUTES.HOME;
  }
  return APP_ROUTES.ALL_SWAG;
});
const mapStateToProps = () => createStructuredSelector({
  link: linkSelector
});
const SwagLogoDynamic = props => {
  const settings = {
    logoLink: storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.logoUrl,
    isHardLink: true,
    imgAlt: () => (storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.storeName) || 'Dynamic'
  };
  return /*#__PURE__*/React.createElement(SwagLogoComponent, _extends({}, props, settings));
};
export const SwagLogo = connect(mapStateToProps)(SwagLogoDynamic);